// extracted by css-extract-rspack-plugin
export default {"panel":"MoreTabPanel_panel__TQJr2"};